import React from "react";
import { Circles } from "react-loader-spinner";

export default function FullScreenLoader(props) {
  return (
    <div className="modal is-active fullScreenLoader">
      <div className="modal-background"></div>
      <div className="modal-content">
        <div className="is-flex is-justify-content-center">
          <Circles color="#00BFFF" height={50} width={50} />
        </div>
        <p>{props.note}</p>
      </div>
    </div>
  );
}
